import type { GranularityType } from "../Chart"
import type { ChartSerieTimeData } from "../useHighchartOptions"

/** @deprecated */
export function hideDataBeforeCurrentPeriod(
  data: ChartSerieTimeData,
  granularity: GranularityType,
): ChartSerieTimeData {
  if (!data.length) {
    return []
  }
  const today = new Date()
  // use timezone etc from the server
  const lastDataPoint = data[data.length - 1]
  if (!lastDataPoint) {
    return data
  }
  const dateToStartDroppingFrom = new Date(lastDataPoint[0])
  dateToStartDroppingFrom.setUTCDate(today.getUTCDate())
  dateToStartDroppingFrom.setUTCMonth(today.getUTCMonth())
  dateToStartDroppingFrom.setUTCFullYear(today.getUTCFullYear())
  dateToStartDroppingFrom.setUTCHours(0, 0, 0, 0)

  switch (granularity) {
    case "quarter": {
      dateToStartDroppingFrom.setUTCDate(1)
      dateToStartDroppingFrom.setUTCMonth(Math.floor(dateToStartDroppingFrom.getUTCMonth() / 3) * 3)
      break
    }
    case "month": {
      dateToStartDroppingFrom.setUTCDate(1)
      break
    }
    case "week": {
      dateToStartDroppingFrom.setUTCDate(
        dateToStartDroppingFrom.getUTCDate() - dateToStartDroppingFrom.getUTCDay() + 1,
      )
      break
    }
  }

  const timestampToStartDroppingFrom = dateToStartDroppingFrom.getTime()

  return data.filter(([timestamp]) => timestamp < timestampToStartDroppingFrom)
}

export function hideInitialPartialPeriod(
  data: ChartSerieTimeData,
  granularity: GranularityType,
): ChartSerieTimeData {
  if (!data.length) {
    return []
  }

  let serieData = data

  const d = new Date(0)
  const firstTimestamp = data?.[0]?.[0]
  d.setUTCSeconds(firstTimestamp ?? 0)

  switch (granularity) {
    case "week": {
      if (d.getUTCDay() !== 1) {
        serieData = serieData.slice(1)
      }
      break
    }
    case "month": {
      if (d.getUTCDate() !== 1) {
        serieData = serieData.slice(1)
      }
      break
    }
    case "quarter": {
      if (d.getUTCMonth() % 3 !== 0) {
        serieData = serieData.slice(1)
      }
      break
    }
  }

  return serieData
}
